import {useElementSize} from '@vueuse/core'
import {defineStore, storeToRefs} from 'pinia'
import {computed} from 'vue'
import {ref} from 'vue'
import {useSessionStore} from '.'

export const useSnapshotOverlayStore = defineStore('videoStore', () => {
  const videoElement = ref<HTMLVideoElement | null>(null)
  const {width: elementWidth, height: elementHeight} = useElementSize(videoElement)
  const session = useSessionStore()
  const {transform} = storeToRefs(session)
  const config = computed(() => {
    if (!videoElement.value) {
      return {
        width: '100vw',
        height: '100vh',
        left: '0px',
        top: '0px',
      }
    }
    const {left: transformLeft, top: transformTop} = transform.value
    const videoWidth = videoElement.value.videoWidth
    const videoHeight = videoElement.value.videoHeight
    const scale = Math.min(elementWidth.value / videoWidth, elementHeight.value / videoHeight)
    const width = videoWidth * scale
    const height = videoHeight * scale

    const left = (elementWidth.value - width) / 2 + transformLeft
    const top = (elementHeight.value - height) / 2 + transformTop
    return {width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px'}
  })
  const snapshotOverlayWidth = computed(() => config.value.width)
  const snapshotOverlayHeight = computed(() => config.value.height)
  const snapshotOverlayLeft = computed(() => config.value.left)
  const snapshotOverlayTop = computed(() => config.value.top)
  return {
    videoElement,
    snapshotOverlayWidth,
    snapshotOverlayHeight,
    snapshotOverlayLeft,
    snapshotOverlayTop,
  }
})
